var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.featuredCharts && _vm.featuredCharts.length)?_c('div',[_c('BaseSection',{attrs:{"show-all-link":{ name: 'browse/charts/index' },"title":"Featured Charts","show-all-title":"Browse More"}},[_c('PlaylistsGridBlock',{attrs:{"playlists":_vm.featuredCharts,"type":"charts","min-tile-width":"160px"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }